// extracted by mini-css-extract-plugin
module.exports = {"root":"PanelHeader-module__root__gC7T4","disabled":"PanelHeader-module__disabled__1AqdM","title":"PanelHeader-module__title__34VRz"};